import { UPDATE_DASHBOARD_TUT_STATUS, FETCH_DASHBOARD_TUT_STATUS_SUCCESS } from './dashboardType';

const initialState = {
  dashboardTuts: {},
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_TUT_STATUS_SUCCESS:
      return {
        ...state,
        dashboardTuts: action.payload.data,
      };

    case UPDATE_DASHBOARD_TUT_STATUS:
      return {
        ...state,
        dashboardTuts: { ...state.dashboardTuts, [action.payload.field]: true },
      };
    default:
      return { ...state };
  }
};

export default dashboardReducer;
